import { Filter } from 'lucide-react';

import { PortainerSelect } from '@@/form-components/PortainerSelect';
import { Icon } from '@@/Icon';
import { InputGroup } from '@@/form-components/InputGroup';

import { CustomResourceDefinition } from '../types';

interface Props {
  crds: CustomResourceDefinition[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function CustomResourceDefinitionGroupFilter({
  crds,
  value,
  onChange,
  placeholder = 'Select a Custom Resource Definition Group',
}: Props) {
  // Get unique groups from CRDs
  const uniqueGroups = Array.from(
    new Set(crds.map((crd) => crd.group).filter(Boolean))
  ).sort();

  const options = uniqueGroups.map((group) => ({
    value: group,
    label: group,
  }));

  return (
    <InputGroup size="small">
      <InputGroup.Addon>
        <div className="flex items-center gap-1">
          <Icon icon={Filter} />
          Group
        </div>
      </InputGroup.Addon>
      <div className="min-w-[400px]">
        <PortainerSelect
          value={value}
          onChange={(newValue) => onChange(newValue || '')}
          options={options}
          placeholder={placeholder}
          isClearable
          bindToBody
          data-cy="crd-group-filter"
          size="sm"
        />
      </div>
    </InputGroup>
  );
}
